import { render, staticRenderFns } from "./styled-dialog-header.vue?vue&type=template&id=20c5c1a7&scoped=true"
import script from "./styled-dialog-header.vue?vue&type=script&lang=js"
export * from "./styled-dialog-header.vue?vue&type=script&lang=js"
import style0 from "./styled-dialog-header.vue?vue&type=style&index=0&id=20c5c1a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5c1a7",
  null
  
)

export default component.exports